import './src/styles/global.css'

export const onRouteUpdate = () => {
  window.scrollTo(0, 0)
}
